module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/whatsapp-badge-0d13f46ffb1ecb0ac57b8c586b652feb.svg";